module.exports = __webpack_public_path__ + "assets/img/9-1.d1ec5b61.png";